import { appStore } from "@store/appStore";

export type SampleFileVariant = "customer" | "ops";

/** Download a generated sample data file (MPN-1445).
 *  variant=customer → shareable template (no is_test column — that flag is
 *  ops-only vocabulary customers must never see);
 *  variant=ops → internal test file, every row flagged is_test=Y so the load
 *  is inert. Saves under the server's routing-convention filename. */
export class CommandDownloadSampleFile {
  async run(
    definitionId: number,
    variant: SampleFileVariant,
    rows = 1,
    asOf?: string,
    fallbackName?: string,
  ): Promise<void> {
    const params = new URLSearchParams({ variant, rows: String(rows) });
    if (asOf) params.set("as_of", asOf);
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/sample-file/?${params}`;
    const resp = await fetch(url, { headers: { Authorization: `Token ${appStore.authToken}` } });
    if (!resp.ok) throw new Error(`Sample file download failed (${resp.status})`);
    // Server-built routing-convention name; readable cross-origin only because the
    // API sets CORS_EXPOSE_HEADERS: content-disposition.
    const match = (resp.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/);
    const blob = await resp.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = match?.[1] || fallbackName || `${variant === "ops" ? "test" : "sample"}.csv`;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }
}
